import { Stat } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const StatStyled = styled(Stat)`
  ${({ theme }) => css`
    & > :first-child {
      color: ${theme.colors.grey[1000]};
      font-size: ${theme.fontSize[700]};
    }
    & > :last-child {
      font-size: ${theme.fontSize[300]};
    }
  `};
`;
